import React from "react";
import { Assets } from "../../types/asset-type";
import { FiCheckCircle } from "react-icons/fi";
import { FaPlay } from "react-icons/fa";
import { MediaThumbnailsProps } from "./types";
import { Loader } from "lucide-react";

const MediaThumbnails: React.FC<MediaThumbnailsProps> = ({
    assets,
    toggleSelectMedia,
    selectedMedia,
    isEditing,
    carouselApi,
    carouselAssetIndexMap,
    isMobile,
    onThumbnailClick,
}) => {
    const handleThumbnailClick = (asset: Assets, idx: number) => {
        if (isEditing) {
            toggleSelectMedia(asset);
        } else if (
            carouselApi &&
            carouselAssetIndexMap[asset.id] !== undefined
        ) {
            const carouselIndex = carouselAssetIndexMap[asset.id];
            carouselApi.scrollTo(carouselIndex);
            onThumbnailClick?.(carouselIndex);
        }
    };

    return (
        <div
            className={`grid ${
                isMobile ? "grid-cols-2" : "grid-cols-5"
            } gap-2 mt-4`}
        >
            {assets?.map((media, idx) => {
                const isSelected = selectedMedia.some((m) => m.id === media.id);

                return (
                    <div
                        key={media.id || media.name}
                        id={`media-${idx}`}
                        className={`relative cursor-pointer group ${
                            isSelected ? "ring-2 ring-secondary rounded" : ""
                        }`}
                        onClick={() => handleThumbnailClick(media, idx)}
                    >
                        {/* fixed 4:3 box that fills its grid cell */}
                        <div className="w-full aspect-[4/3] overflow-hidden rounded">
                            <img
                                src={
                                    media.thumbnail ||
                                    media.signedUrl ||
                                    media.url
                                }
                                alt={media.name}
                                className="w-full h-full object-contain border"
                            />

                            {media.assetType === "Video" && (
                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded">
                                    <FaPlay className="text-white" size={24} />
                                </div>
                            )}

                            {media.isProcessing && (
                                <>
                                    <div className="absolute right-2 bottom-2">
                                        <Loader className="animate-spin text-white" />
                                    </div>
                                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-75 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                        <span className="text-white text-sm text-center">
                                            Video Processing
                                        </span>
                                        <Loader className="ml-2 animate-spin text-secondary" />
                                    </div>
                                </>
                            )}

                            {isEditing && (
                                <div className="absolute top-2 left-2 bg-primary flex items-center justify-center p-1 rounded-xl w-[25px] h-[25px]">
                                    {isSelected && (
                                        <FiCheckCircle className="text-secondary text-[18px]" />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default MediaThumbnails;
